export type DevMarket = 'cz' | 'sk';

export function resolveDevMarket(): DevMarket {
  const value = import.meta.env.VITE_DEV_MARKET?.trim().toLowerCase();
  if (value === 'sk' || value === 'cz') {
    return value;
  }
  return 'cz';
}
